import _ from "lodash";
import styles from "./ProgressBar.module.scss";

export type ProgressBarType = "default" | "grey" | "blue";
export type ProgressBarSize = "large" | "small";

export default function ProgressBar({
  value,
  showPercentage = true,
  type = "default",
  size = "large",
}: {
  value?: number;
  showPercentage?: boolean;
  type?: ProgressBarType;
  size?: ProgressBarSize;
}) {
  const percentage = _.round((value || 0) * 100, 2);
  const percentageMinMax = _.round(_.min([_.max([percentage, 0]), 100]) || 0, 2);

  return (
    <div className={`${styles["progress-bar"]} ${styles[type]} ${styles[size]}`}>
      <div className={styles.inner}>
        <div
          className={styles.bar}
          style={{ width: `${percentageMinMax}%` }}
        ></div>
      </div>
      {showPercentage && <div className={styles.percentage}>{percentage}%</div>}
    </div>
  );
}
